import axios from 'axios';
import httpInstance from './interceptor';
import { throwErr } from './throwError';
import { LOGIN, FORGOT_PASSWORD, LOGOUT, RESET_PASSWORD, USER_SELF, USER_LDAP, LOGIN_CONFIG, LOGIN_AZURE, VERIFY_TWOFA_CODE, RESEND_TWOFA_CODE } from 'fixtures/api';

export const login = async (user) => {
  let data = await axios.post(LOGIN, user).then((res) => {
    return res.data
  }).catch((err) => throwErr(err))

  return data
}

export const logout = async () => {
  let data = await httpInstance.get(LOGOUT).then((res) => {
    return true
  }).catch((err) => throwErr(err))

  return data
}

export const getMyDetails = async () => {
  let data = await httpInstance.get(USER_SELF).then((res) => {
    return res.data
  }).catch((err) => throwErr(err))

  return data
}

export const getLdapUserDetails = async (username) => {
  let data = await httpInstance.get(USER_LDAP(username)).then((res) => {
    return res.data
  }).catch((err) => {
    if (err.response.status === 404) {
      alert(err.response.data.error)
    }
  })

  return data
}

export const sendForgotPassword = async (data) => {
  let res = await axios({
    method: 'post',
    url: FORGOT_PASSWORD,
    data: data,
    headers: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
  })

  return res
}

export const sendResetPassword = async (data, token) => {
  let res = await axios({
    method: 'post',
    url: RESET_PASSWORD,
    data: data,
    headers: {
      'content-type': 'application/json;charset=utf-8',
      'Authorization': `Bearer ${token}`
    }
  })

  return res
}

export const loginConfig = async () => {
  let res = await axios({
    method: 'get',
    url: LOGIN_CONFIG,
  })

  return res.data
}

export const loginAzure = async (token) => {
  let res = await axios({
    method: 'post',
    url: LOGIN_AZURE,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })

  return res.data
}

export const verifyTwoFaCode = async (user) => {
  let data = await axios.post(VERIFY_TWOFA_CODE, user).then((res) => {
    return res.data
  }).catch((err) => throwErr(err))

  return data
}

export const resendTwoFaCode = async (user) => {
  let data = await axios.post(RESEND_TWOFA_CODE, user).then((res) => {
    return res.data
  }).catch((err) => throwErr(err))

  return data
}
